// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1_VE_","cls2":"CreateSocialItemModal-cls2_qPU CreateSocialItemModal-cls1_VE_"};